import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BeninFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14350'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14350)'>
				<g filter='url(#filter0_d_2332_14350)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V6.53333H0V14Z'
						fill='#F12641'
					/>
				</g>
				<g filter='url(#filter1_d_2332_14350)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 6.53333H20V0H0V6.53333Z'
						fill='#FFD648'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H7.61905V0H0V14Z'
					fill='#17A668'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_14350'
					x='0'
					y='6.53333'
					width='20'
					height='7.46667'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14350'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14350'
						result='shape'
					/>
				</filter>
				<filter
					id='filter1_d_2332_14350'
					x='0'
					y='0'
					width='20'
					height='6.53333'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14350'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14350'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default BeninFlagIcon;
